import { render, staticRenderFns } from "./BpCheckboxGroup.vue?vue&type=template&id=d486415c&"
import script from "./BpCheckboxGroup.vue?vue&type=script&lang=js&"
export * from "./BpCheckboxGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports